import { ToastNotifierReducerState } from './types';

export const getDefaultState = (): ToastNotifierReducerState => ({
  notifications: []
});
